module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "using System;\r\nusing System.Numerics;\r\nusing System.Threading.Tasks;\r\nusing Nethereum.Contracts;\r\nusing Nethereum.Hex.HexTypes;\r\nusing Nethereum.RPC.Eth.DTOs;\r\n\r\n// Created with 'Nethereum-CodeGenerator' https://github.com/StefH/Nethereum-CodeGenerator by stef.heyenrath@mstack.nl (mStack B.V.)\r\n// Based on abi-code-gen (https://github.com/Nethereum/abi-code-gen)\r\nnamespace <%= locals.namespace ? namespace : 'DefaultNamespace' %>\r\n{\r\n    public interface I<%= capitalizeFirstLetter(getContractName()) %>Service\r\n    {\r\n        Task<TransactionReceipt> ExecuteTransactionAsync(Func<I<%= capitalizeFirstLetter(getContractName()) %>Service, Task<string>> func, int timeoutInSeconds = 120);\r\n\r\n        Task<BlockWithTransactions> GetBlockWithTransactionsAsync(string blockhash);\r\n\r\n<%#= abi.forEach(generateGetFunction) %>\r\n<%= abi.forEach(generateGetEvent) %>\r\n<%= abi.forEach(generateFunctionCall) %>\r\n<%= abi.forEach(generateFunctionTransaction) %>\r\n<%= abi.forEach(generateFunctionCallMultipleOutputsDTO) %>\r\n    }\r\n}\r\n<%_\r\nfunction getContractName() {\r\n   return locals._contractName ? locals._contractName : 'DefaultContractName';\r\n}\r\n\r\nfunction capitalizeFirstLetter(string) {\r\n    return string.charAt(0).toUpperCase() + string.slice(1);\r\n}\r\n\r\nfunction abiToText(abi) {\r\n    return JSON.stringify(abi).split('\\\"').join('\\\"\\\"');\r\n}\r\n\r\nfunction getGenericReturnType(item) {\r\n    var returnType = getReturnType(item);\r\n    return item === null ? '' : '<' + returnType + '>';\r\n}\r\n\r\nfunction generateFunctionInputParameters(item) {\r\n    var params = '';\r\n    if (item.inputs !== null && item.inputs.length > 0) {\r\n        \r\n        item.inputs.forEach(function(input, index) {\r\n            var prefix = ', ';\r\n            if (params === '') {\r\n                prefix = '';\r\n            }\r\n            params = params + prefix + getTypeMap(input.type) + ' ' + getParamName(input.name, index);\r\n        })\r\n    }\r\n    return params;\r\n}\r\n\r\nfunction getParamName(param, index) {\r\n    if (param !== '') {\r\n        return param;\r\n    }\r\n\r\n    switch (index) {\r\n        case 0:\r\n            return 'a';\r\n        case 1:\r\n            return 'b';\r\n        case 2:\r\n            return 'c';\r\n        case 3:\r\n            return 'd';\r\n        case 4:\r\n            return 'e';\r\n        case 5:\r\n            return 'f';\r\n        case 6:\r\n            return 'g';\r\n    }\r\n    return 'h';\r\n}\r\n\r\nfunction generateFunctionTransactionInputParameters(item) {\r\n    var params = generateFunctionInputParameters(item);\r\n\r\n    return params !== '' ? params + ',' : params;\r\n}\r\n\r\nfunction generateConstructorInputParameters(abi) {\r\n    var ret = '';\r\n    abi.forEach(function(item) {\r\n        if (item.type === 'constructor') {\r\n            ret = generateFunctionTransactionInputParameters(item);\r\n        }\r\n    });\r\n    return ret;\r\n}\r\n\r\nfunction generateConstructorParameters(abi) {\r\n    var ret = '';\r\n    abi.forEach( function(item) {\r\n        if (item.type === 'constructor') {\r\n            ret = generateFunctionParametersCommaPrefix(item);\r\n        }\r\n    });\r\n    return ret;\r\n}\r\n\r\nfunction generateFunctionParametersCommaPrefix(item) {\r\n    var ret = generateFunctionParameters(item);\r\n    return ret !== '' ? ', ' + ret : ret;\r\n}\r\n\r\nfunction generateFunctionParameters(item) {\r\n    var params = '';\r\n    if (item.inputs !== null && item.inputs.length > 0) {\r\n        \r\n        item.inputs.forEach( function(input, index) {\r\n            var prefix = ', ';\r\n            if (params === '') {\r\n                prefix = '';\r\n            }\r\n            params = params + prefix + getParamName(input.name, index);\r\n        })\r\n    } \r\n    return params;\r\n}\r\n\r\nfunction getReturnType(item) {\r\n    if (item.outputs !== null && item.outputs.length === 1) {\r\n        return getTypeMap(item.outputs[0].type);\r\n    }\r\n    return null;\r\n}\r\n\r\nfunction getTypeMap(typeName) {\r\n    var indexFirstBracket = typeName.indexOf('[');\r\n    if (indexFirstBracket > -1) {\r\n        var elementTypeName = typeName.substring(0, indexFirstBracket);\r\n        return getTypeMap(elementTypeName) + '[]';\r\n    }\r\n\r\n    if ('bool' === typeName) {\r\n        return typeName;\r\n    }\r\n\r\n    if (typeName.startsWith('int')) {\r\n        // default\r\n        if (typeName.length === 3) {\r\n            return 'BigInteger';\r\n        }\r\n\r\n        var length = parseInt(typeName.substring(3));\r\n        \r\n        if (length > 64) {\r\n            return 'BigInteger';\r\n        }\r\n\r\n        if (length <= 64 && length > 32) {\r\n            return 'long';\r\n        }\r\n\r\n        // ints are in 8 bits\r\n        if (length === 32 ) {\r\n            return 'int';\r\n        }\r\n\r\n        if (length === 16 ) {\r\n            return 'short';\r\n        }\r\n\r\n        if (length === 8 ) {\r\n            return 'sbyte';\r\n        }\r\n    }\r\n\r\n    if (typeName.startsWith('uint')) {\r\n       \r\n        if (typeName.length === 4) {\r\n            return 'BigInteger';\r\n        }\r\n\r\n        var length = parseInt(typeName.substring(4));\r\n        \r\n        if (length > 64) {\r\n            return 'BigInteger';\r\n        }\r\n\r\n        if (length <= 64 && length > 32) {\r\n            return 'ulong';\r\n        }\r\n        \r\n        // uints are in 8 bits steps\r\n        if (length === 32 ) {\r\n            return 'int';\r\n        }\r\n\r\n        if (length === 16 ) {\r\n            return 'short';\r\n        }\r\n\r\n        if (length === 8 ) {\r\n            return 'byte';\r\n        }\r\n    }\r\n\r\n    if (typeName === 'address') {\r\n        return 'string';\r\n    }\r\n\r\n    if (typeName === 'string') {\r\n        return 'string';\r\n    }\r\n\r\n    if (typeName === 'bytes') {\r\n        return 'byte[]';\r\n    }\r\n\r\n    // if (typeName === 'bytes32') {\r\n    //     return 'string';\r\n    // }\r\n\r\n    if (typeName.startsWith('bytes')) {\r\n        return 'byte[]';\r\n    }\r\n}\r\n\r\n_%>\r\n<%_ function generateGetFunction(item) { _%>\r\n<%_ if (item.type === 'function') { _%>\r\n        Function GetFunction<%= capitalizeFirstLetter(item.name) %>();\r\n<%_ } }\r\n_%>\r\n<%_ function generateGetEvent(item) { _%>\r\n<%_ if (item.type === 'event') { _%>\r\n<%_ var eventName = capitalizeFirstLetter(item.name); _%>\r\n        Event<<%=eventName%>> Get<%=eventName%>();\r\n<%_ } }\r\n_%>\r\n<%_ function generateFunctionCall_Original(item) { _%>\r\n<%_ if (item.type === 'function' && (item.outputs !== null && item.outputs.length === 1)) { _%>\r\n        Task<%- getGenericReturnType(item) -%> <%= capitalizeFirstLetter(item.name) %>CallAsync(<%- generateFunctionInputParameters(item) -%>);\r\n<%_ } }\r\n_%>\r\n<%_ function generateFunctionCall(item) { _%>\r\n<%_ if (item.type === 'function' && (item.outputs !== null && item.outputs.length === 1)) { _%>\r\n        Task<%- getGenericReturnType(item) -%> <%= capitalizeFirstLetter(item.name) %>CallAsync(<%- generateFunctionInputParameters(item) -%>);\r\n        Task<%- getGenericReturnType(item) -%> <%= capitalizeFirstLetter(item.name) %>CallAsync(string addressFrom, <%- generateFunctionTransactionInputParameters(item) -%> HexBigInteger gas = null, HexBigInteger valueAmount = null);\r\n<%_ } }\r\n_%>\r\n<%_ function generateFunctionCallMultipleOutputsDTO_Original(item) { _%>\r\n<%_ if (item.type === 'function' && (item.outputs !== null && item.outputs.length > 1)) { _%>\r\n        Task<<%- capitalizeFirstLetter(item.name) -%>> <%= capitalizeFirstLetter(item.name) %>CallAsync(<%- generateFunctionInputParameters(item) -%>);\r\n<%_ } }\r\n_%>\r\n<%_ function generateFunctionCallMultipleOutputsDTO(item) { _%>\r\n<%_ if (item.type === 'function' && (item.outputs !== null && item.outputs.length > 1)) { _%>\r\n        Task<<%- capitalizeFirstLetter(item.name) -%>> <%= capitalizeFirstLetter(item.name) %>CallAsync(<%- generateFunctionInputParameters(item) -%>);\r\n        Task<<%- capitalizeFirstLetter(item.name) -%>> <%= capitalizeFirstLetter(item.name) %>CallAsync(string addressFrom, <%- generateFunctionTransactionInputParameters(item) -%> HexBigInteger gas = null, HexBigInteger valueAmount = null);\r\n<%_ } }\r\n_%>\r\n<%_ function generateFunctionTransaction(item) { _%>\r\n<%_ if (item.type === 'function' && item.constant === false) { _%>\r\n        Task<string> <%= capitalizeFirstLetter(item.name) %>Async(string addressFrom, <%- generateFunctionTransactionInputParameters(item) -%> HexBigInteger gas = null, HexBigInteger valueAmount = null);\r\n<%_ } }\r\n_%>\r\n<%_ function generateFunctionOutputDTOProperty(param, index) { _%>\r\n        [Parameter(\"<%=param.type%>\", \"<%=param.name%>\", <%=index + 1%>)]\r\n        public <%-getTypeMap(param.type)-%> <%-capitalizeFirstLetter(getParamName(param.name, index))-%> {get; set;}\r\n\r\n<%_ }\r\n_%>\r\n<%_ function generateFunctionOutputDTO(item) { _%>\r\n<%_ if (item.type === 'function' && item.outputs !== null && item.outputs.length > 1 ) { _%>\r\n    [FunctionOutput]\r\n    public class <%=capitalizeFirstLetter(item.name)%> \r\n    {\r\n<%- item.outputs.forEach(generateFunctionOutputDTOProperty) -%>\r\n    }\r\n<%_ } }\r\n_%>\r\n_%>"
  , __filename = "src\\business\\cs-service-interface.ejs";
try {
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("using System;\r\nusing System.Numerics;\r\nusing System.Threading.Tasks;\r\nusing Nethereum.Contracts;\r\nusing Nethereum.Hex.HexTypes;\r\nusing Nethereum.RPC.Eth.DTOs;\r\n\r\n// Created with 'Nethereum-CodeGenerator' https://github.com/StefH/Nethereum-CodeGenerator by stef.heyenrath@mstack.nl (mStack B.V.)\r\n// Based on abi-code-gen (https://github.com/Nethereum/abi-code-gen)\r\nnamespace ")
    ; __line = 10
    ; __append(escapeFn( locals.namespace ? namespace : 'DefaultNamespace' ))
    ; __append("\r\n{\r\n    public interface I")
    ; __line = 12
    ; __append(escapeFn( capitalizeFirstLetter(getContractName()) ))
    ; __append("Service\r\n    {\r\n        Task<TransactionReceipt> ExecuteTransactionAsync(Func<I")
    ; __line = 14
    ; __append(escapeFn( capitalizeFirstLetter(getContractName()) ))
    ; __append("Service, Task<string>> func, int timeoutInSeconds = 120);\r\n\r\n        Task<BlockWithTransactions> GetBlockWithTransactionsAsync(string blockhash);\r\n\r\n")
    ; __line = 18
    ; __append("\r\n")
    ; __line = 19
    ; __append(escapeFn( abi.forEach(generateGetEvent) ))
    ; __append("\r\n")
    ; __line = 20
    ; __append(escapeFn( abi.forEach(generateFunctionCall) ))
    ; __append("\r\n")
    ; __line = 21
    ; __append(escapeFn( abi.forEach(generateFunctionTransaction) ))
    ; __append("\r\n")
    ; __line = 22
    ; __append(escapeFn( abi.forEach(generateFunctionCallMultipleOutputsDTO) ))
    ; __append("\r\n    }\r\n}\r\n")
    ; __line = 25
    ; 
function getContractName() {
   return locals._contractName ? locals._contractName : 'DefaultContractName';
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function abiToText(abi) {
    return JSON.stringify(abi).split('\"').join('\"\"');
}

function getGenericReturnType(item) {
    var returnType = getReturnType(item);
    return item === null ? '' : '<' + returnType + '>';
}

function generateFunctionInputParameters(item) {
    var params = '';
    if (item.inputs !== null && item.inputs.length > 0) {
        
        item.inputs.forEach(function(input, index) {
            var prefix = ', ';
            if (params === '') {
                prefix = '';
            }
            params = params + prefix + getTypeMap(input.type) + ' ' + getParamName(input.name, index);
        })
    }
    return params;
}

function getParamName(param, index) {
    if (param !== '') {
        return param;
    }

    switch (index) {
        case 0:
            return 'a';
        case 1:
            return 'b';
        case 2:
            return 'c';
        case 3:
            return 'd';
        case 4:
            return 'e';
        case 5:
            return 'f';
        case 6:
            return 'g';
    }
    return 'h';
}

function generateFunctionTransactionInputParameters(item) {
    var params = generateFunctionInputParameters(item);

    return params !== '' ? params + ',' : params;
}

function generateConstructorInputParameters(abi) {
    var ret = '';
    abi.forEach(function(item) {
        if (item.type === 'constructor') {
            ret = generateFunctionTransactionInputParameters(item);
        }
    });
    return ret;
}

function generateConstructorParameters(abi) {
    var ret = '';
    abi.forEach( function(item) {
        if (item.type === 'constructor') {
            ret = generateFunctionParametersCommaPrefix(item);
        }
    });
    return ret;
}

function generateFunctionParametersCommaPrefix(item) {
    var ret = generateFunctionParameters(item);
    return ret !== '' ? ', ' + ret : ret;
}

function generateFunctionParameters(item) {
    var params = '';
    if (item.inputs !== null && item.inputs.length > 0) {
        
        item.inputs.forEach( function(input, index) {
            var prefix = ', ';
            if (params === '') {
                prefix = '';
            }
            params = params + prefix + getParamName(input.name, index);
        })
    } 
    return params;
}

function getReturnType(item) {
    if (item.outputs !== null && item.outputs.length === 1) {
        return getTypeMap(item.outputs[0].type);
    }
    return null;
}

function getTypeMap(typeName) {
    var indexFirstBracket = typeName.indexOf('[');
    if (indexFirstBracket > -1) {
        var elementTypeName = typeName.substring(0, indexFirstBracket);
        return getTypeMap(elementTypeName) + '[]';
    }

    if ('bool' === typeName) {
        return typeName;
    }

    if (typeName.startsWith('int')) {
        // default
        if (typeName.length === 3) {
            return 'BigInteger';
        }

        var length = parseInt(typeName.substring(3));
        
        if (length > 64) {
            return 'BigInteger';
        }

        if (length <= 64 && length > 32) {
            return 'long';
        }

        // ints are in 8 bits
        if (length === 32 ) {
            return 'int';
        }

        if (length === 16 ) {
            return 'short';
        }

        if (length === 8 ) {
            return 'sbyte';
        }
    }

    if (typeName.startsWith('uint')) {
       
        if (typeName.length === 4) {
            return 'BigInteger';
        }

        var length = parseInt(typeName.substring(4));
        
        if (length > 64) {
            return 'BigInteger';
        }

        if (length <= 64 && length > 32) {
            return 'ulong';
        }
        
        // uints are in 8 bits steps
        if (length === 32 ) {
            return 'int';
        }

        if (length === 16 ) {
            return 'short';
        }

        if (length === 8 ) {
            return 'byte';
        }
    }

    if (typeName === 'address') {
        return 'string';
    }

    if (typeName === 'string') {
        return 'string';
    }

    if (typeName === 'bytes') {
        return 'byte[]';
    }

    // if (typeName === 'bytes32') {
    //     return 'string';
    // }

    if (typeName.startsWith('bytes')) {
        return 'byte[]';
    }
}


    ; __line = 227
    ; __line = 228
    ;  function generateGetFunction(item) { 
    ; __line = 229
    ;  if (item.type === 'function') { 
    ; __append("        Function GetFunction")
    ; __line = 230
    ; __append(escapeFn( capitalizeFirstLetter(item.name) ))
    ; __append("();\r\n")
    ; __line = 231
    ;  } }

    ; __line = 232
    ; __line = 233
    ;  function generateGetEvent(item) { 
    ; __line = 234
    ;  if (item.type === 'event') { 
    ; __line = 235
    ;  var eventName = capitalizeFirstLetter(item.name); 
    ; __append("        Event<")
    ; __line = 236
    ; __append(escapeFn(eventName))
    ; __append("> Get")
    ; __append(escapeFn(eventName))
    ; __append("();\r\n")
    ; __line = 237
    ;  } }

    ; __line = 238
    ; __line = 239
    ;  function generateFunctionCall_Original(item) { 
    ; __line = 240
    ;  if (item.type === 'function' && (item.outputs !== null && item.outputs.length === 1)) { 
    ; __append("        Task")
    ; __line = 241
    ; __append( getGenericReturnType(item) )
    ; __append(" ")
    ; __append(escapeFn( capitalizeFirstLetter(item.name) ))
    ; __append("CallAsync(")
    ; __append( generateFunctionInputParameters(item) )
    ; __append(");\r\n")
    ; __line = 242
    ;  } }

    ; __line = 243
    ; __line = 244
    ;  function generateFunctionCall(item) { 
    ; __line = 245
    ;  if (item.type === 'function' && (item.outputs !== null && item.outputs.length === 1)) { 
    ; __append("        Task")
    ; __line = 246
    ; __append( getGenericReturnType(item) )
    ; __append(" ")
    ; __append(escapeFn( capitalizeFirstLetter(item.name) ))
    ; __append("CallAsync(")
    ; __append( generateFunctionInputParameters(item) )
    ; __append(");\r\n        Task")
    ; __line = 247
    ; __append( getGenericReturnType(item) )
    ; __append(" ")
    ; __append(escapeFn( capitalizeFirstLetter(item.name) ))
    ; __append("CallAsync(string addressFrom, ")
    ; __append( generateFunctionTransactionInputParameters(item) )
    ; __append(" HexBigInteger gas = null, HexBigInteger valueAmount = null);\r\n")
    ; __line = 248
    ;  } }

    ; __line = 249
    ; __line = 250
    ;  function generateFunctionCallMultipleOutputsDTO_Original(item) { 
    ; __line = 251
    ;  if (item.type === 'function' && (item.outputs !== null && item.outputs.length > 1)) { 
    ; __append("        Task<")
    ; __line = 252
    ; __append( capitalizeFirstLetter(item.name) )
    ; __append("> ")
    ; __append(escapeFn( capitalizeFirstLetter(item.name) ))
    ; __append("CallAsync(")
    ; __append( generateFunctionInputParameters(item) )
    ; __append(");\r\n")
    ; __line = 253
    ;  } }

    ; __line = 254
    ; __line = 255
    ;  function generateFunctionCallMultipleOutputsDTO(item) { 
    ; __line = 256
    ;  if (item.type === 'function' && (item.outputs !== null && item.outputs.length > 1)) { 
    ; __append("        Task<")
    ; __line = 257
    ; __append( capitalizeFirstLetter(item.name) )
    ; __append("> ")
    ; __append(escapeFn( capitalizeFirstLetter(item.name) ))
    ; __append("CallAsync(")
    ; __append( generateFunctionInputParameters(item) )
    ; __append(");\r\n        Task<")
    ; __line = 258
    ; __append( capitalizeFirstLetter(item.name) )
    ; __append("> ")
    ; __append(escapeFn( capitalizeFirstLetter(item.name) ))
    ; __append("CallAsync(string addressFrom, ")
    ; __append( generateFunctionTransactionInputParameters(item) )
    ; __append(" HexBigInteger gas = null, HexBigInteger valueAmount = null);\r\n")
    ; __line = 259
    ;  } }

    ; __line = 260
    ; __line = 261
    ;  function generateFunctionTransaction(item) { 
    ; __line = 262
    ;  if (item.type === 'function' && item.constant === false) { 
    ; __append("        Task<string> ")
    ; __line = 263
    ; __append(escapeFn( capitalizeFirstLetter(item.name) ))
    ; __append("Async(string addressFrom, ")
    ; __append( generateFunctionTransactionInputParameters(item) )
    ; __append(" HexBigInteger gas = null, HexBigInteger valueAmount = null);\r\n")
    ; __line = 264
    ;  } }

    ; __line = 265
    ; __line = 266
    ;  function generateFunctionOutputDTOProperty(param, index) { 
    ; __append("        [Parameter(\"")
    ; __line = 267
    ; __append(escapeFn(param.type))
    ; __append("\", \"")
    ; __append(escapeFn(param.name))
    ; __append("\", ")
    ; __append(escapeFn(index + 1))
    ; __append(")]\r\n        public ")
    ; __line = 268
    ; __append(getTypeMap(param.type))
    ; __append(" ")
    ; __append(capitalizeFirstLetter(getParamName(param.name, index)))
    ; __append(" {get; set;}\r\n\r\n")
    ; __line = 270
    ;  }

    ; __line = 271
    ; __line = 272
    ;  function generateFunctionOutputDTO(item) { 
    ; __line = 273
    ;  if (item.type === 'function' && item.outputs !== null && item.outputs.length > 1 ) { 
    ; __append("    [FunctionOutput]\r\n    public class ")
    ; __line = 275
    ; __append(escapeFn(capitalizeFirstLetter(item.name)))
    ; __append(" \r\n    {\r\n")
    ; __line = 277
    ; __append( item.outputs.forEach(generateFunctionOutputDTOProperty) )
    ; __append("    }\r\n")
    ; __line = 279
    ;  } }

    ; __line = 280
    ; __line = 281
  }
  return __output.join("");
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}